import React from 'react';

const EmptySection = ({ message }) => {
  return (
    <p className="text-sm text-muted-foreground italic py-2">{message}</p>
  );
};

export default EmptySection;
